import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';
import gettext from '@eb/gettext';
import { NotificationBar } from '@eb/eds-notification';
import { ENV_SHAPE_PROP_TYPE } from '@eb/site-structure';
import { DEFAULT_ORGANIZER_ID, ORGANIZER_SHAPE } from '../constants';
import EventsScreenHeader from './EventsScreenHeader';
import ConnectedEventsFilterGroup from '../containers/EventsFilterGroup';

const getHTMLFromText = (htmlMessage) => (
    // eslint-disable-next-line react/no-danger
    <div dangerouslySetInnerHTML={{ __html: htmlMessage }} />
);

const InvoiceDueNotification = ({ amount, helpLink }) => {
    const message = gettext(
        'Your invoice for %(amount)s is due today. <a href="/invoices">Pay now</a> or <a href="%(helpLink)s" target="_blank" rel="noopener noreferrer">learn more about invoices</a>.',
        { amount, helpLink },
    );

    return <NotificationBar>{getHTMLFromText(message)}</NotificationBar>;
};

export default class EventsScreenLayout extends PureComponent {
    static propTypes = {
        baseUrl: PropTypes.string.isRequired,
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        addMainNotification: PropTypes.func,
        organizers: PropTypes.arrayOf(ORGANIZER_SHAPE),
        searchQuery: PropTypes.string,
        organizerId: PropTypes.string,
        isEmbedded: PropTypes.bool,
        crumb: PropTypes.string,
        disableFilterGroupDefaultValues: PropTypes.bool,
    };

    static defaultProps = {
        organizerId: DEFAULT_ORGANIZER_ID,
        isEmbedded: false,
    };

    _getCmsNotifications = () => {
        const { cmsContent: { alert } = {}, isEmbedded } = this.props;
        let notifications;

        // If we are embedded in the manage's eventsScreen
        // we need to hide this banner
        if (alert && !isEmbedded) {
            const alertContent = (
                <NotificationBar
                    type={TYPE_ERROR}
                    iconType={<AlertChunky />}
                    hasCloseButton={true}
                    data-spec="events-screen-cms-alert"
                >
                    {getHTMLFromText(alert)}
                </NotificationBar>
            );

            notifications = (
                <div className="eds-g-cell eds-g-cell-1-1 eds-l-mar-top-1">
                    {alertContent}
                </div>
            );
        }

        return notifications;
    };

    _getInvoiceNotifications = () => {
        const { invoiceDue, isEmbedded } = this.props;

        // If we are embedded in the manage's eventsScreen
        // we need to hide this banner
        let invoiceDueNotification;
        if (invoiceDue && !isEmbedded) {
            invoiceDueNotification = (
                <InvoiceDueNotification
                    amount={invoiceDue.amount}
                    helpLink={invoiceDue.helpLink}
                    data-spec="invoice-due-notification"
                />
            );
        }

        return invoiceDueNotification;
    };

    render() {
        const {
            isEmbedded,
            request,
            organizers,
            organizerId,
            baseUrl,
            searchQuery,
            location,
            disableFilterGroupDefaultValues,
        } = this.props;
        let header;
        let className;

        if (!isEmbedded) {
            header = <EventsScreenHeader />;
            className = 'eds-l-mar-bot-20 eds-l-pad-bot-20';
        }

        // NOTE: Need to leave enough space at the bottom so that the last couple of more action palettes can fit on the screen
        // Need to use both padding and margin to get enough space
        return (
            <div className={className} data-spec="events-screen">
                {this._getCmsNotifications()}
                {this._getInvoiceNotifications()}
                {header}
                <ConnectedEventsFilterGroup
                    baseUrl={baseUrl}
                    searchQuery={searchQuery}
                    request={request}
                    organizers={organizers}
                    organizerId={organizerId}
                    location={location}
                    disableFilterGroupDefaultValues={
                        disableFilterGroupDefaultValues
                    }
                />
                {this.props.children}
            </div>
        );
    }
}
